import { useState, useEffect, useRef } from "react";
import { Room, RoomEvent, Track } from "livekit-client";
import { useLocation } from "react-router-dom";
import left from '../assets/left.png'
import { UpdateUserLimits ,UpdateAnalytics} from '../Firebase'


const LiveStreaming = () => {
    const location = useLocation();

    const { voiceID, avatarID } = location.state || {}; // Fallback if no state


    const [taskInput, setTaskInput] = useState("");
    const mediaElementRef = useRef(null);
    const [sessionInfo, setSessionInfo] = useState(null);
    const [sessionID, setSessionID] = useState(null);
    const [sessionToken, setSessionToken] = useState(null);
    const [sessionStarted, setSessionStarted] = useState(false);
    const [room, setRoom] = useState(null);
    const [playbackFailed, setPlaybackFailed] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false)

    const [isAlertOpen, setAlertOpen] = useState(false)

    const [loading, setLoading] = useState(false)
    const [timer, setTimer] = useState(0); // Timer state to track loading time
    const [phone, setPhone] = useState("")

    const API_CONFIG = {
        apiKey: "Njc0NDNkNzg3ZTczNDA3YjkwYTI5ZGU3ZmZiNzNiNDMtMTcxOTQ4Mjk5Mg==",
        serverUrl: "https://api.heygen.com",
    };

    useEffect(() => {
        const userData = JSON.parse(sessionStorage.getItem("AI_UserData"))
        setPhone(userData.phone)

        setLoading(true)
        const initializeSession = async () => {
            try {
                console.log("Fetching session token...");
                const response = await fetch(`${API_CONFIG.serverUrl}/v1/streaming.create_token`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": API_CONFIG.apiKey,
                    },
                });
                const data = await response.json();
                setSessionToken(data.data.token);
                console.log("Session token received:", data.data.token);

                console.log("Creating new session...");
                const sessionResponse = await fetch(`${API_CONFIG.serverUrl}/v1/streaming.new`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${data.data.token}`,
                    },
                    body: JSON.stringify({
                        version: "v2",
                        quality: "medium",
                        avatar_name: avatarID,
                        voice: {
                            voice_id: voiceID,
                            rate: 1,
                        },
                        video_encoding: "H264",
                    }),
                });

                const sessionData = await sessionResponse.json();
                setSessionInfo(sessionData.data);
                console.log("Session initialized:", sessionData.data);

                setSessionID(sessionData.data.session_id)


                console.log("Starting the session...");
                const startResponse = await fetch(`${API_CONFIG.serverUrl}/v1/streaming.start`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${data.data.token}`,
                    },
                    body: JSON.stringify({ session_id: sessionData.data.session_id }),
                });
                const startData = await startResponse.json();
                // console.log("Session started successfully:", startData);
                setSessionStarted(true);

                console.log("Connecting to LiveKit room...");
                const newRoom = new Room();
                await newRoom.connect(sessionData.data.url, sessionData.data.access_token);
                setRoom(newRoom);

                newRoom.on(RoomEvent.TrackSubscribed, (track, publication, participant) => {
                    //console.log(`Track received: ${track.kind} from ${participant.identity}`);

                    if (track.kind === Track.Kind.Audio) {
                        console.log("Audio track detected.");
                    }

                    if (track.kind === Track.Kind.Video || track.kind === Track.Kind.Audio) {
                        if (!mediaElementRef.current.srcObject) {
                            mediaElementRef.current.srcObject = new MediaStream();
                        }

                        const mediaStream = mediaElementRef.current.srcObject;
                        mediaStream.addTrack(track.mediaStreamTrack);

                        mediaElementRef.current.muted = false; // Unmute
                        mediaElementRef.current.volume = 1.0; // Set volume to maximum
                        mediaElementRef.current.play().catch((error) => {
                            console.warn("Autoplay failed, waiting for user interaction.", error);
                            setPlaybackFailed(true);
                        });

                        //console.log(`Track added: ${track.kind}`);
                    }
                });


                setLoading(false)
                console.log("sessionID :", sessionID)

            } catch (error) {
                console.error("Error initializing session:", error);
            }
        };

        if (userData.streaming_limit === 0) {
            setAlertOpen(true)
        } else {
            initializeSession();
            UpdateAnalytics('streaming')
        }


    }, []);

    useEffect(() => {
        const timerInterval = setInterval(() => {
            if (!loading) {
                setTimer((prevTimer) => {
                    const newTimer = prevTimer + 1;
                    console.log("Timer:", newTimer); // Log the updated timer
    
                    // Trigger actions when timer reaches 51 seconds
                    if (newTimer === 51) {
                        // Call asynchronous functions
                        const handleTimeout = async () => {
                            await stopSession();
                            setAlertOpen(true);
                            await UpdateUserLimits("streaming_limit", phone, newTimer);
                        };
    
                        handleTimeout();
    
                        // Stop the interval after reaching the desired time
                        clearInterval(timerInterval);
                    }
                    return newTimer;
                });
            }
        }, 1000);
    
        return () => clearInterval(timerInterval); // Cleanup on unmount
    }, [loading]);
    


    const handleUserInteraction = () => {
        if (mediaElementRef.current) {
            mediaElementRef.current.play().then(() => {
                setPlaybackFailed(false);
            }).catch((error) => {
                console.error("Error resuming video playback:", error);
            });
        }
    };

    const sendText = async () => {
        if (!sessionInfo || !sessionStarted || !taskInput.trim()) {
            console.warn("No active session, session not started, or empty input");
            return;
        }
        try {
            console.log("Sending text to avatar:", taskInput);
            setButtonLoader(true)
            await fetch(`${API_CONFIG.serverUrl}/v1/streaming.task`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionToken}`,
                },
                body: JSON.stringify({
                    session_id: sessionInfo.session_id,
                    text: taskInput,
                    task_type: "talk",
                }),
            });
            setButtonLoader(false)
            setTaskInput("");
        } catch (error) {
            console.error("Error sending text:", error);
        }
    };

    const stopSession = async () => {
        try {
            const response = await fetch(`${API_CONFIG.serverUrl}/v1/streaming.stop`, { // Use the correct endpoint
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": API_CONFIG.apiKey,
                },
                body: JSON.stringify({ session_id: sessionID }) // Properly stringify the body
            });

            if (!response.ok) {
                throw new Error(`Failed to stop session: ${response.statusText}`);
            }

            const data = await response.json();
            console.log("Session stopped successfully:", data);
        } catch (error) {
            console.error("Error stopping session:", error);
        }
    };

    async function exitStreaming() {

        stopSession()
        UpdateUserLimits("streaming_limit", phone, timer)
        window.history.back()
    }

    return (
        <div className="d-flex flex-column justify-content-between " style={{ height: '100vh' }} >

            <div className='container pt-4 p-0'>

                <div className='back-button' onClick={() => exitStreaming()}>
                    <img src={left} />
                    <h1 className='m-0' >Live Streaming</h1>
                </div>

            </div>

            {loading ? (
                <span className="Spinloader"></span>
            ) : isAlertOpen ? (
                <div
                    className={`alert alert-danger alert-dismissible fade show`}
                    data-aos="fade-right"
                    role="alert"
                >
                    <h3>You Have Reached Your Generation Limit!</h3>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        
                    ></button>
                </div>
            ) : (
                <video
                    ref={mediaElementRef}
                    className="w-100 max-h-[400px] border rounded-lg my-5"
                    autoPlay
                    playsInline
                    muted={true}
                    volume={1.0}
                ></video>
            )}


            <div className="container" >
                <div className="d-flex flex-column ">
                    <h2>Prompt</h2>
                    <input
                        type="text"
                        value={taskInput}
                        onChange={(e) => setTaskInput(e.target.value)}
                        placeholder="Enter text for avatar to speak"
                        className="flex-1 min-w-[200px] p-2 border border-gray-300 rounded-md"
                    />
                    <button
                        onClick={sendText}
                        className="main-button mt-2 mb-4 ${buttonloader ? backgroundcolor:#3d3d3d : black}">
                        {buttonLoader ? "Sending ..." : "Send"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LiveStreaming;
